/**
 * 接口 / WebSocket 地址（2026-09-17）
 *
 * 网页端一律用「当前打开的域名」：同一份构建部署到立方镜 6 台（1001 + 分台 1118/1777/8008/8668/1699），
 * 各台 PC 域名不同（web.fjly001.top、web1118.fjly001.top、web1699.box001.top…），写死任何一个都会让
 * 其它台的 PC 用户请求打到那一台（登录、消息全串台）。分台现网 dist 以前就是就地打补丁改成 location.origin 的。
 *
 * Electron 桌面端页面是本地文件，没有可用的域名，仍用 .env 里的 VUE_APP_BASE_API / VUE_APP_WS_URL。
 */
const isElectron = !!process.env.IS_ELECTRON;

export const apiBase = () => isElectron ? process.env.VUE_APP_BASE_API : location.origin + '/api';

export const wsUrl = () => isElectron ? process.env.VUE_APP_WS_URL :
	(location.protocol == 'https:' ? 'wss://' : 'ws://') + location.host + '/im';
